<template>
  <div class="player-stat">
    <div class="outer">
      <div class="inner">
        <i class="top left"></i>
        <i class="top right"></i>
        <div class="content option">

          <div class="row">
            <div class="col-9 pr-1">
              <div class="stat-container stats p-1">
                <div class="row mt-1">
                  <div class="col-3">
                    <img loading="lazy" sizes="100%, 100%" class="icon-image" :src="iconImage"
                         :title="ucHuman(icon)" :alt="ucHuman(icon)">
                  </div>

                  <div class="col-4">
                    <input class="form-control form-control-sm stat-input" :value="value + boost" tabindex="-1" readonly>
                  </div>
                  <span class="stat-divider">/</span>
                  <div class="col-4">
                    <input class="form-control form-control-sm stat-input" :value="value" @change="statChange">
                  </div>
                </div>
              </div>

            </div>

            <div class="col-3 pl-1">
              <div class="stat-container potions p-1" v-if="potions.length > 0">
                <InventorySlot :id="activePotion.id" :selected-item="activePotion"
                               :itemSlot="itemSlot"
                               :items="potions" @update="potionUpdate"></InventorySlot>
              </div>
            </div>
          </div>



        </div>
        <i class="bottom right"></i>
        <i class="bottom left"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import InventorySlot from "./gear-selector/InventorySlot";

  export default {
    name: "PlayerStat",
    components: {InventorySlot},
    props: {
      icon: {
        type: String,
        default: 'hitpoints'
      },
      itemSlot: {
        type: String,
        default: 'hitpoints'
      },
      activePotion: {
        type: Object,
        default() {
          return {id: 0}
        }
      },
      potions: {
        type: Array,
        default() {
          return []
        }
      },
      value: {
        type: Number,
        default: 99,
      },
      boost: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    computed: {
      iconImage: function () {
        return `/static/images/icons/${this.icon}.png`
      },
      contextClass: function () {
        return {
          'boosted': this.boost > 0,
        }
      },
    },
    methods: {
      addOperator: function (val) {
        if (val > 0) {
          return '+' + val
        }

        return val;
      },
      potionUpdate: function (itemSlot, potion) {
        this.$emit('potionUpdate', itemSlot, potion);
      },
      statChange: function(evt) {
       this.$emit('update', this.itemSlot, parseInt(evt.target.value))
      }
    }
  }
</script>

<style scoped>
  .stat-container {
    /*background: #464644;*/
    /*border: 1px solid black;*/
  }

  .stat-input {
    background: #5A5952;
    color: #F5FC00;
    /*margin-top: 5%;*/
    /*height: 100%;*/
    font-weight: bold;
    /*font-size: 1.8rem;*/
    /*line-height: 1.8rem;*/
    text-align: center;
    letter-spacing: 0.1rem;
  }

  .stat-divider {
    /*font-size: 2rem;*/
    font-weight: bolder;
    color: black;
  }

  .stat-value {
    font-weight: bold;
    line-height: 30px;
  }

  .stat-value.boosted {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlayerStat.vue